/**
 * 区域树遍历、提交前 areaIds 展开等纯函数
 */

/**
 * 在区域树中按 uuid 查找节点
 */
export function findAreaNodeByUuid (nodes, uuid) {
  if (!nodes || !uuid) return null;
  for (const node of nodes) {
    if (node.uuid === uuid) return node;
    if (node.children && node.children.length) {
      const found = findAreaNodeByUuid(node.children, uuid);
      if (found) return found;
    }
  }
  return null;
}

/**
 * 根据选中大区 id 解析展示名称（递归整棵树）
 */
export function getZoneNameFromTree (areaTree, zoneAreaId) {
  if (!zoneAreaId || !areaTree || !areaTree.length) return '';
  const find = (nodes) => {
    for (const n of nodes) {
      if (n.uuid === zoneAreaId) return n.areaName;
      if (n.children) {
        const r = find(n.children);
        if (r) return r;
      }
    }
    return '';
  };
  return find(areaTree);
}

/**
 * 将区域 ID 列表规范为「自身 + 从根到该节点的祖先链」上的 ID 集合（去重）。
 * 与 el-cascader emitPath:false 一致：勾选叶子只 emit 叶子 id，提交前在此补上祖先链；
 * 库内若已存叶子与祖先 id，再次调用不会向下展开子孙。
 */
export function collectAllAreaIds (areaIds, areaTree) {
  const result = new Set();

  const findAndCollect = (nodes, id) => {
    for (const node of nodes) {
      if (node.uuid === id) {
        result.add(node.uuid);
        return true;
      }
      if (node.children && findAndCollect(node.children, id)) {
        result.add(node.uuid);
        return true;
      }
    }
    return false;
  };

  (areaIds || []).forEach(id => findAndCollect(areaTree, id));
  return [...result];
}
